//Values will change depending on what the API will accept
export type IntervalTypes = 'day' | 'week' | 'month';
export type DayTypes = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';
export type WeekTypes = 'first' | 'second' | 'third' | 'fourth' | 'last';
export type TimezoneTypes = 'pst' | 'mst' | 'cst' | 'est' | 'utc';

export type TimeInfo = {
  time?: string;
  timeZone: TimezoneTypes;
};

export type IntervalInfo = {
  count: number;
  type: IntervalTypes;
  days?: DayTypes[];
  week?: WeekTypes;
};

export type DatesInfo = {
  hasEndDate: boolean;
  startDate?: string;
  endDate?: string;
};

export type FrequencyConfig = {
  intervalInfo: IntervalInfo;
  timeInfo: TimeInfo;
  datesInfo: DatesInfo;
};

export const dayTypesDict: Record<DayTypes, { label: string; id: number }> = {
  mon: { label: 'Monday', id: 0 },
  tue: { label: 'Tuesday', id: 1 },
  wed: { label: 'Wednesday', id: 2 },
  thu: { label: 'Thursday', id: 3 },
  fri: { label: 'Friday', id: 4 },
  sat: { label: 'Saturday', id: 5 },
  sun: { label: 'Sunday', id: 6 },
};

export const timezoneDict: Record<TimezoneTypes, string> = {
  pst: 'PST',
  mst: 'MST',
  cst: 'CST',
  est: 'EST',
  utc: 'UTC',
};

export const intervalTypesDict: Record<IntervalTypes, string> = {
  day: 'daily',
  week: 'weekly',
  month: 'monthly',
};
